import { render, staticRenderFns } from "./CheckoutRedirector.vue?vue&type=template&id=b7eb08e8&"
import script from "./CheckoutRedirector.vue?vue&type=script&lang=js&"
export * from "./CheckoutRedirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports